import React from 'react'

import BoraBora from '../assets/image1.jpg';
import BoraBora2 from '../assets/image2.webp';
import Maldives from '../assets/image3.jpg';
import Maldives2 from '../assets/image4.jpg';
import Maldives3 from '../assets/image5.jpg';
import KeyWest from '../assets/more.jpg';
import SelectsCard from './SelectsCard';

const Selects = ({usageRef}) => {
  return (
    <>
    
    <div className='max-w-[1240px] mx-auto lg:grid-cols-1 gap-4 px-4 text-center'>
      <h2 ref={usageRef}>All Gems</h2>
    </div>
    <div className='max-w-[1240px] mx-auto px-4 pt-8 pb-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-4'>

    <SelectsCard bg={BoraBora} text='Green Bowl Beach' />
    <SelectsCard bg={BoraBora2} text='beachside caves' />
    <SelectsCard bg={Maldives} text='Nyang Nyang Beach' />
    <SelectsCard bg={Maldives2} text='Secret Wild Garden' />
    <SelectsCard bg={Maldives3} text='Gunung Payung Beach' />
    <SelectsCard bg={KeyWest} text='And More ..' />
    
        
    </div>
    </>
    
  )
}

export default Selects